import { render } from "./MobileForm.vue?vue&type=template&id=12ae825d"
import script from "./MobileForm.vue?vue&type=script&lang=js"
export * from "./MobileForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__